import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { ifDefined as l } from '../../../../node_modules/lit-html/directives/if-defined.js';
import { unsafeHTML as o } from '../../../../node_modules/lit-html/directives/unsafe-html.js';
import { BaseWithUtils } from '../../lit-mixins/base-with-utils/index.js';
import '../../atoms/buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import css_248z from './image-block.scss.js';

const LitElementWithUtils = BaseWithUtils(s);
class ImageBlock extends LitElementWithUtils {
    constructor() {
        super(...arguments);
        this.transparent = false;
        this.landscape = false;
        this.carousel = false;
        this.fitImage = false;
        this.fullWidth = false;
        this.componentType = '';
        this.id = '';
        this.imageId = '';
        this.imageUrl = '';
        this.imageAltText = '';
        this.loadingHint = 'lazy';
        this.figCaptionId = '';
        this.imageCaption = '';
        this.insideTextBlock = false;
        this.insideSocialProof = false;
        this.aspectClass = '';
    }
    firstUpdated(_changedProperties) {
        var _a, _b;
        (_a = super.firstUpdated) === null || _a === void 0 ? void 0 : _a.call(this, _changedProperties);
        const img = (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('img');
        if (img === null || img === void 0 ? void 0 : img.complete) {
            this.setAspectClass(img);
        }
        else {
            img === null || img === void 0 ? void 0 : img.addEventListener('load', () => this.setAspectClass(img));
        }
        const parent = this.parentNode;
        if ((parent === null || parent === void 0 ? void 0 : parent.tagName.toLowerCase()) === 'text-block')
            this.insideTextBlock = true;
        if ((parent === null || parent === void 0 ? void 0 : parent.tagName.toLowerCase()) === 'social-proof-item')
            this.insideSocialProof = true;
    }
    setAspectClass(img) {
        const ratio = img.naturalWidth / img.naturalHeight;
        const aspectMap = [
            { value: 1.0, class: 'aspect-1-1' },
            { value: 4 / 3, class: 'aspect-4-3' },
            { value: 3 / 2, class: 'aspect-3-2' },
            { value: 16 / 9, class: 'aspect-16-9' },
            { value: 2.0, class: 'aspect-2-1' },
            { value: 21 / 9, class: 'aspect-21-9' },
        ];
        const closest = aspectMap.reduce((prev, curr) => Math.abs(curr.value - ratio) < Math.abs(prev.value - ratio)
            ? curr
            : prev, aspectMap[0]);
        this.aspectClass = closest.class;
    }
    render() {
        const classes = [
            'image-block',
            this.utilityClasses,
            this.alignment,
            this.fullWidth && 'fullWidth',
            this.insideTextBlock && 'insideTextBlock',
            this.insideSocialProof && 'inside-social-proof',
            this.fitImage && 'fit-image',
            this.transparent && 'transparent',
            this.carousel && 'carousel',
            (this.rtl || isRTL()) && 'rtl',
            this.componentType === 'multicomponent' && 'full-image-multicomponent',
            this.aspectClass,
        ]
            .filter(Boolean)
            .join(' ');
        // The nested logic is extracted into this constant
        const describedbyValue = this.imageCaption
            ? `${this.id}-${this.figCaptionId}`
            : undefined;
        return $ `<div class="image-container ${classes}"><figure id="${l(this.id ? `${this.id}-figure` : undefined)}" class="${classes}"><img src="${this.imageUrl}" id="${l(this.id ? `${this.id}-${this.imageId}` : undefined)}" alt="${this.imageAltText}" loading="${this.loadingHint}" decoding="async" aria-describedby="${l(describedbyValue)}"><figcaption id="${l(this.id ? `${this.id}-${this.figCaptionId}` : undefined)}">${o(this.imageCaption)}</figcaption></figure></div>`;
    }
}
ImageBlock.styles = [LitElementWithUtils.styles || [], css_248z];
__decorate([
    e({ type: String })
], ImageBlock.prototype, "alignment", void 0);
__decorate([
    e({ type: Boolean })
], ImageBlock.prototype, "rtl", void 0);
__decorate([
    e({ type: Boolean })
], ImageBlock.prototype, "transparent", void 0);
__decorate([
    e({ type: Boolean })
], ImageBlock.prototype, "landscape", void 0);
__decorate([
    e({ type: Boolean })
], ImageBlock.prototype, "carousel", void 0);
__decorate([
    e({ type: Boolean })
], ImageBlock.prototype, "fitImage", void 0);
__decorate([
    e({ type: Boolean })
], ImageBlock.prototype, "fullWidth", void 0);
__decorate([
    e({ type: String })
], ImageBlock.prototype, "componentType", void 0);
__decorate([
    e({ type: String })
], ImageBlock.prototype, "id", void 0);
__decorate([
    e({ type: String })
], ImageBlock.prototype, "imageId", void 0);
__decorate([
    e({ type: String })
], ImageBlock.prototype, "imageUrl", void 0);
__decorate([
    e({ type: String })
], ImageBlock.prototype, "imageAltText", void 0);
__decorate([
    e({ type: String })
], ImageBlock.prototype, "loadingHint", void 0);
__decorate([
    e({ type: String })
], ImageBlock.prototype, "figCaptionId", void 0);
__decorate([
    e({ type: String })
], ImageBlock.prototype, "imageCaption", void 0);
__decorate([
    t()
], ImageBlock.prototype, "insideTextBlock", void 0);
__decorate([
    t()
], ImageBlock.prototype, "insideSocialProof", void 0);
__decorate([
    t()
], ImageBlock.prototype, "aspectClass", void 0);
customElements.define('image-block', ImageBlock);

export { ImageBlock };
